<div class="position-relative">
  <button #treeButton type="button" [disabled]="isControlDisabled" [ngStyle]="{ 'width': width + unitType}" class="dropdown-toggle"
          (click)="op.toggle($event);calculateCoords(treeButton)">
    <span *ngIf="selectedTexts?.length == 0" class="text-truncate">Select</span>
    <span *ngIf="selectedTexts?.length > 0" class="text-truncate">{{ selectedTexts.join(",") }}</span>
  </button>
  <p-overlayPanel styleClass="drp_treeview" appendTo="body" #op [style]="{ 'width': treeviewOverlay + 'px','margin-top':offSet.top+'px','margin-left':offSet.left+'px' }">
    <ng-template pTemplate>
      <p-tree [value]="datasource" (onNodeSelect)="handleSelection($event)"
              (onNodeUnselect)="!isSingleSelection?handleSelection($event):''" filterPlaceholder="search tree"
              [(selection)]="isSingleSelection?selectedValue: selectedvalArray" [filter]="true" filterMode="strict"
              [selectionMode]="isSingleSelection?'single':'checkbox'" scrollHeight="{{height + unitType}}">
      </p-tree>
    </ng-template>
  </p-overlayPanel>
</div>


